const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/gerar-resumo-de-lancamento-de-notas-conceitos",
    name: "gerar-resumo-de-lancamento-de-notas-conceitos",
    meta: {
      allowedPermissions: [
        "resumo_notas_conceitos_insert",
        "resumo_notas_conceitos_delete",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/GerarResumoDeLancamentoDeNotasConceitos/GerarResumoDeLancamentoDeNotasConceitosHome.vue"
      ),
  },
];

export default routes;
